"use client"
import { GetPageQuery } from "apollo"
import { HomeIcon } from "ui/icons"

import { getParentsArray } from "lib/utils"
import {
  BrandsValue,
  CustomBreadcrumbs,
  DealsCarousel,
  MainContainer,
} from "ui"
import { BlockRenderer, findProperty } from "utils"
import ImageWithContainer from "./ImageWithContainer"
import QuoteWrapper from "./QuoteWrapper"

type Props = {
  data: GetPageQuery
}

const components = {
  imagnextTextSlider: BrandsValue,
  topBanner: ImageWithContainer,
  imageTextBlock: QuoteWrapper,
  DealsCarousel: DealsCarousel,
}

function Yellow({ data }: Props) {
  const parents = getParentsArray(data.page, 3)
  return (
    <>
      <MainContainer mediumRightGap={150} rightGap={150}>
        <CustomBreadcrumbs
          current={parents[parents.length - 1]}
          parents={[{ title: <HomeIcon />, url: "/" }, ...parents.slice(0, -1)]}
        />
      </MainContainer>
      {findProperty(data.page, "blocks")?.blocks?.map(
        // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
        (block: any, index: number) => (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            props={{ withCover: true, subWeight: 300 }}
            components={components}
          ></BlockRenderer>
        ),
      )}
    </>
  )
}

export default Yellow
